import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useFetchSeoSettings } from '../data/fetchSeoSettings';
import { SeoContext } from '../data/seo/SeoContextProvider';
import SeoMainContainer from '../data/seo/SeoMainContainer';
import { useHandleSeoSettings } from '../data/seo/seoUtils';
import { getConfiguration } from '../data/utils/configuration';
import { scrollPositionsByKey } from '../utils/scroll-restoration';
import { useUserSettings } from './UserSettingsProvider';
import Legend from './legend/Legend';

function RestoreScrollPosition() {
    const location = useLocation();

    useEffect(() => {
        const scrollerContainer = document.getElementById('xs-scroller-container');
        if (scrollerContainer != null && scrollPositionsByKey.has(location.pathname)) {
            const prevScrollingPosition = scrollPositionsByKey.get(location.pathname);
            if (prevScrollingPosition) {
                scrollerContainer.scrollTop = prevScrollingPosition;
            }
            scrollPositionsByKey.delete(location.pathname);
        }
    });
}

export default function ScrollerContainer(props) {
    const scroller = useRef(null);
    const topButtonEnabled = useUserSettings()?.showGoToTopButton ?? false;
    const [showTopButton, setShowTopButton] = useState(false);
    const conf = getConfiguration();
    const seoContext = React.useContext(SeoContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext && seoContext.pathname, true, conf.seo);
    useHandleSeoSettings(seoSettingsState);

   useEffect(() => {
    const container = conf.iwh ? window : scroller.current;
    const scrollHeight = conf.iwh ? 161 : 100;

    function getScrollTop() {
        if (conf.iwh) {
            return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        } else {
            return container?.scrollTop || 0;
        }
    }

    function handler() {
        const scrollTop = getScrollTop();

        if (scrollTop > scrollHeight) {
            if (!showTopButton) {
                setShowTopButton(true);
            }

            document.documentElement.style.setProperty("--xs_liveTrackerWrapper-height", "161px");
            document.querySelector('.xs_liveTrackerWrapper')?.classList.add('scale-widget');
        } else {
            document.documentElement.style.removeProperty("--xs_liveTrackerWrapper-height");
            setShowTopButton(false);
            document.querySelector('.xs_liveTrackerWrapper')?.classList.remove('scale-widget');
        }
    }

    container?.addEventListener('scroll', handler, { passive: true });

    return () => container?.removeEventListener('scroll', handler);
}, []);


    function handleClick() {
        scroller.current.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <div id="xs-scroller-container" className="h-full overflow-y-scroll pb-[100px]" ref={scroller}>
            {props.children}
            {!props.isMyBets &&
                <>
                   {/*  <SeoBreadcrumb /> */}
                    <SeoMainContainer />
                </>
            }
            {topButtonEnabled && showTopButton &&
                <div className="xs_goToTopButton z-50 absolute bottom-[160px] right-[20px] h-[50px] w-[50px] bg-cc1 border-[2px] border-cs1 rounded-full opacity-[0.4] flex items-center content-center" onClick={handleClick}>
                    <i className="bi-arrow-up m-auto text-xl text-cs1" />
                </div>
            }
            <RestoreScrollPosition />
            {!props.isMyBets &&
                <Legend />
            }
        </div>
    );
}
